import { PromotionBanner } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";

interface HolidayGiftBannerProps {
  onClick: () => void;
}

export function HolidayGiftBanner(props: HolidayGiftBannerProps) {
  const { onClick } = props;

  const title = "You've earned a gift!";
  const subtitle = "A token of appreciation for reaching 1,000 Clipboard Score";
  const ctaButtonText = "What is it?";

  return (
    <Box>
      <PromotionBanner
        title={title}
        subtitle={subtitle}
        icon="gift-lavender-colored"
        borderVariant="none"
        backgroundColor={(_theme) => "linear-gradient(126deg, #FBF2E8 15.55%, #DEF1E8 97.06%)"}
        ctaButtonText={ctaButtonText}
        sx={{
          height: "100%",
          "& svg": {
            alignSelf: "flex-start",
          },
        }}
        onClick={onClick}
      />
    </Box>
  );
}
